const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDomainName(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6.69885 2.05756C6.998 1.67796 7.43298 1.33203 8.00094 1.33203C8.56891 1.33203 9.00389 1.67796 9.30304 2.05756C9.60812 2.44467 9.85371 2.96352 10.0476 3.54524C10.3864 4.56168 10.6044 5.8829 10.6558 7.33203H5.34605C5.39752 5.8829 5.61546 4.56168 5.95428 3.54524C6.14818 2.96352 6.39377 2.44467 6.69885 2.05756Z",
    fill: "#1859FF",
    style: {
      fill: "#1859FF",
      fill: "color(display-p3 0.0941 0.3490 1.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.01194 7.33203C4.06379 5.76687 4.29796 4.29775 4.68936 3.12352C4.82038 2.73046 4.98197 2.33083 5.18362 1.95475C3.10107 2.92719 1.60423 4.94431 1.36719 7.33203H4.01194Z",
    fill: "#1859FF",
    style: {
      fill: "#1859FF",
      fill: "color(display-p3 0.0941 0.3490 1.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.3672 8.66536H4.01194C4.06381 10.2305 4.29797 11.6995 4.68936 12.8737C4.82038 13.2668 4.98197 13.6664 5.18362 14.0425C3.10111 13.0701 1.60429 11.053 1.3672 8.66536Z",
    fill: "#1859FF",
    style: {
      fill: "#1859FF",
      fill: "color(display-p3 0.0941 0.3490 1.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.34605 8.66536H10.6558C10.6044 10.1145 10.3864 11.4357 10.0476 12.4522C9.85371 13.0339 9.60812 13.5527 9.30304 13.9398C9.00389 14.3194 8.56891 14.6654 8.00094 14.6654C7.43298 14.6654 6.998 14.3194 6.69885 13.9398C6.39377 13.5527 6.14818 13.0339 5.95428 12.4522C5.61546 11.4357 5.39752 10.1145 5.34605 8.66536Z",
    fill: "#1859FF",
    style: {
      fill: "#1859FF",
      fill: "color(display-p3 0.0941 0.3490 1.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9899 8.66536C11.9381 10.2305 11.7039 11.6995 11.3125 12.8737C11.1815 13.2668 11.0199 13.6664 10.8183 14.0425C12.9008 13.0701 14.3976 11.053 14.6347 8.66536H11.9899Z",
    fill: "#1859FF",
    style: {
      fill: "#1859FF",
      fill: "color(display-p3 0.0941 0.3490 1.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6347 7.33203C14.3977 4.94431 12.9008 2.92719 10.8183 1.95475C11.0199 2.33083 11.1815 2.73046 11.3125 3.12352C11.7039 4.29775 11.9381 5.76687 11.99 7.33203H14.6347Z",
    fill: "#1859FF",
    style: {
      fill: "#1859FF",
      fill: "color(display-p3 0.0941 0.3490 1.0000)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDomainName);
export default __webpack_public_path__ + "static/media/icon_domain_name.8385ae0d9014d727ec338936485a4495.svg";
export { ForwardRef as ReactComponent };